import React from 'react';
import { Link } from 'react-router-dom';

/**
 * Consistent "there is nothing here yet" block used by the account tabs,
 * wishlist and cart. Explains what is missing and offers the next step.
 */
export default function EmptyState({ icon, title, text, actionLabel, actionTo, onAction, className = '' }) {
  return (
    <div className={`eg-emptystate ${className}`}>
      {icon && <div className="eg-emptystate__icon">{icon}</div>}
      <h3 className="eg-emptystate__title">{title}</h3>
      {text && <p className="eg-emptystate__text">{text}</p>}
      {actionLabel && (actionTo ? (
        <Link to={actionTo} className="sf__btn sf__btn-primary">{actionLabel}</Link>
      ) : (
        <button type="button" className="sf__btn sf__btn-primary" onClick={onAction}>{actionLabel}</button>
      ))}
    </div>
  );
}
